import React, {useState, useEffect} from 'react';

const LoadingText = () => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDots((prevDots) => {
        if (prevDots === '...') {
          return '';
        } else {
          return prevDots + '.';
        }
      });
    }, 500);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <span className='loading-text'>
      Loading {dots}
    </span>
  );
};

export default LoadingText;
